'use strict';

// 聚合页链接
export const COLLECTION_LINK = {
    US: '/',
    CA: '/pages/solar-generator',
    GB: '/',
    DE: '/',
    FR: '/',
    IT: '/',
    ES: '/',
    JP: '/collections/all?sort_by=created-descending',
    AU: '/',
    EU: '/',
}

// Referral 跳转地址
export const REFERRAL_LINK = {
  US: '/pages/referral-program',
  CA: '/pages/referral-program',
  GB: '/pages/referral-program',
  AU: '/pages/referral-program',
  JP: '/pages/referral-program',
  DE: '/pages/referral-program',
  IT: '/pages/referralprogram',
  FR: '/pages/referral-program',
  ES: '/pages/referralprogram',
  EU: '/pages/referral-program',
}

// 获取 assets 静态资源
export const getAssetsFile = (dir, url) => {
  return new URL(`../assets/${dir}/${url}`, import.meta.url).href
}

const padLeftZero = (str) => {
  return ('00' + str).substr(str.length)
};

// 手机验证
export const verifyMobile = (str) => {
  const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
  return reg.test(str)
}

// 验证是否移动端
export const isMobile = () => {
  return navigator.userAgent.match(/(iPhone|iPod|Android|ios|SymbianOS|BlackBerry|webOS)/i)
}

// 邮箱验证
export const verifyEmail = (str) => {
  const reg = /^[A-Za-z0-9._%+!`#$^-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,8}$/;
  return reg.test(str)
}

// 密码组合验证, 6-16位必须包含数字和字母
export const verifyPassWdCompose = (str) => {
  return !/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,16}$/.test(str)
}

// 空值
export const isEmpty = (v) => {
  switch (typeof v) {
    case 'undefined':
      return true;
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length === 0) return true;
      break;
    case 'boolean':
      if (!v) return true;
      break;
    case 'number':
      if (0 === v || isNaN(v)) return true;
      break;
    case 'object':
      if (null === v || v.length === 0) return true;
      for (let i in v) {
        return false;
      }
      return true;
  }
  return false
}

// 将浮点数四舍五入, 取小数点后2位
export const toDecimal2 = (x) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false
  }

  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

// 时间格式化
export const formatDate = (date, fmt) => {
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt
}

// 获取当前月份的第一天
export const getMonthStart = () => {
  let date = new Date();
  date.setDate(1);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

// 计算时间差
export const timeDifference = (t1, t2, back) => {
  let date3 = new Date(t2).getTime() - new Date(t1).getTime(); //时间差的毫秒数

  // 相差天
  let days = Math.floor(date3 / (24 * 3600 * 1000));

  // 相差小时
  let leave1 = date3 % (24 * 3600 * 1000);
  let hours = Math.floor(leave1 / (3600 * 1000));

  // 相差分钟
  let leave2 = leave1 % (3600 * 1000);
  let minutes = Math.floor(leave2 / (60 * 1000));

  // 相差秒
  let leave3 = leave2 % (60 * 1000);
  let seconds = Math.round(leave3 / 1000);

  back(days, hours, minutes, seconds);
  //alert(" 相差 "+days+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
}


const typeOf = (obj) => Object.prototype.toString.call(obj).slice(8, -1)

// 深度拷贝
export const deepClone = (data) => {
  const t = typeOf(data);
  let o;

  if (t === 'Array') {
    o = []
  } else if (t === 'Object') {
    o = {}
  } else {
    return data
  }

  if (t === 'Array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepClone(data[i]))
    }
  } else if (t === 'Object') {
    for (let i in data) {
      o[i] = deepClone(data[i])
    }
  }
  return o
}

// 生成一段密钥
export const secretKey = () => {
  let s = [];
  let hexDigits = "0123456789abcdefghijklmnopqrstuvwxyz";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x24), 1);
  }
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);

  let key = s.join("") + '-' + new Date().getTime();
  let encodedString = encodeURIComponent(key)
  return window.btoa(encodedString)
}

export const getOS = () => {
  let ua = navigator.userAgent;

  if (navigator.platform === "Mac68K" || navigator.platform === "MacPPC" || navigator.platform === "Macintosh" || navigator.platform === "MacIntel") {
    return "Mac"
  }
  if (navigator.platform === "X11") {
    return "Unix"
  }
  if ((String(navigator.platform).indexOf("Linux") > -1)) {
    return "Linux"
  }

  if (navigator.platform === "Win32" || navigator.platform === "Windows") {
    if (ua.indexOf("Windows NT 5.0") > -1 || ua.indexOf("Windows 2000") > -1) return "Win2000";
    if (ua.indexOf("Windows NT 5.1") > -1 || ua.indexOf("Windows XP") > -1) return "WinXP";
    if (ua.indexOf("Windows NT 5.2") > -1 || ua.indexOf("Windows 2003") > -1) return "Win2003";
    if (ua.indexOf("Windows NT 6.0") > -1 || ua.indexOf("Windows Vista") > -1) return "WinVista";
    if (ua.indexOf("Windows NT 6.1") > -1 || ua.indexOf("Windows 7") > -1) return "Win7";
    if (ua.indexOf("Windows NT 10") > -1 || ua.indexOf("Windows 10") > -1) return "Win10";
  }
  return "other";
}

// 复制到剪贴板
export const copyToClipboard = (s) => {
  if (window.clipboardData) {
    window.clipboardData.setData('text', s);
  } else {
    (function (s) {
      document.oncopy = function (e) {
        e.clipboardData.setData('text', s);
        e.preventDefault();
        document.oncopy = null
      }
    })(s);
    document.execCommand('Copy')
  }
}

// 复制文本
export const copyText = text => {
  return new Promise((resolve, reject) => {
      if (text && (typeof text === 'number' || typeof text === 'string')) {
          text = String(text);
          let oInput = null
          if (document.querySelector('.oInput')) {
              oInput = document.querySelector('.oInput');
              oInput.style.display = 'block';
          } else {
              oInput = document.createElement('input');
              document.body.appendChild(oInput);
              oInput.className = 'oInput';
          }
          oInput.value = text;
          oInput.select();
          document.execCommand('copy');
          oInput.style.display = 'none';
          resolve(text);
      } else {
          reject('The parameter must be Number or String.');
      }
  });
}

// 获取上传的文件
export const readFile = (file) => {
  let img, reader = new FileReader();
  reader.readAsDataURL(file);

  return new Promise(resolve => {
    reader.onload = function (e) {
      img = reader.result;
      resolve(img)
    }
  })
}

// 取两个数组的差集, [1,2,3,4] and [1,2,7,8] => [3,4,7,8]
export const arrayDifference = (arr1, arr2) => {
  return arr1.filter(function (v) {
    return !(arr2.indexOf(v) > -1)
  }).concat(arr2.filter(function (v) {
    return !(arr1.indexOf(v) > -1)
  }))
}

// 获取浏览器URL传参
export const getUrlParam = (variable) => {
  let reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  let context = "";
  if (r != null) {
    context = r[2];
  }
  reg = null;
  r = null;
  return context == null || context === "" || context === "undefined" ? "" : context;
}

// 拆分url字符串
export const parseUrl = (u) => {
  let nation = {"www.jackery.com": "en-US", "www.jackery.jp": "ja-JP", "uk.jackery.com": "en-GB", "de.jackery.com": "de-DE", "ca.jackery.com": "en-CA"};
  let regExp = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
  let result = regExp.exec(u);
  let names = ['refUrl', 'scheme', 'slash', 'refName', 'refPort', 'refPath', 'refQuery', 'refHash'];
  let arr = {};
  for (let i = 0, len = names.length; i < len; i += 1) { arr[names[i]] = result[i] }
  arr['refNation'] = nation[arr['refName']] || '';
  return arr
}

export const getHashParam = (name) => {
  let reg = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)', "");
  let r = window.location.hash.substr(1).match(reg);
  return r && r[1] || null
}

export const cookie = {
  set(name, value, exDays = 7) {
    let d = new Date(), host = location.host;
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
    let expires = `expires=${d.toGMTString()}`;

    if (host.split('.').length === 1) {
      document.cookie = `${name}=${value}; ${expires}; path=/`
    } else {
      let domainParts = host.split('.');
      domainParts.shift();
      let domain = '.'+domainParts.join('.');
      document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain}`
    }
  },
  get(n) {
    let name = n + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  },
  erase(name) {
    this.set(name, "", -1)
  }
}

// 数字千分号分割
export function toThousands(num) {
  let source = String(num).split(".");
  source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
  return source.join(".");
}

//四舍五入保留2位小数（若第二位小数为0，则保留一位小数）
export function keepTwoDecimal(num) {
  let result = parseFloat(num);
  if (isNaN(result)) {
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result;
}

// 全字段模糊匹配
export const fuzzyQuery = (arr, q) => {
  return arr.filter(v => Object.values(v).some(v => new RegExp(q + '').test(v)))
}

// 获取国旗svg
export const nationalFlag = (v) => {
  let svg = '';
  switch (v) {
    case "CN":
      svg += '<g fill-rule="nonzero"><path d="M0.12535486,19.2629045 L29.8746452,19.2629045 L29.8746452,0.118835832 L0.12535486,0.118835832 L0.12535486,19.2629045 Z M0,19.3846154 L0,0 L30,0 L30,19.3846154 L0,19.3846154 Z" fill="#353636"></path><polygon fill="#E50012" points="30 20 0 20 0 0 30 0"></polygon><path d="M5.0165794,1.89071546 L5.65573322,3.74275479 L7.72352672,3.74275479 L6.05047615,4.88916525 L6.68866007,6.74309636 L5.0165794,5.59668591 L3.34158906,6.74309636 L3.98074288,4.88916525 L2.30769231,3.74275479 L4.37645571,3.74275479 L5.0165794,1.89071546 L5.0165794,1.89071546 Z M10.4071968,0.923076923 L10.3645219,1.56343986 L10.9959166,1.79991066 L10.3373651,1.95881905 L10.2917806,2.59918199 L9.92807393,2.05624501 L9.26952242,2.21515341 L9.70403063,1.72234823 L9.340324,1.18035715 L9.97268862,1.41777384 L10.4071968,0.923076923 L10.4071968,0.923076923 Z M12.7310398,2.99929059 L12.4206768,3.57060405 L12.9007696,4.02462799 L12.2296096,3.92247261 L11.9173068,4.49378607 L11.8135292,3.86004431 L11.1404294,3.75788893 L11.7466071,3.46939454 L11.6437994,2.83565279 L12.1219524,3.28967674 L12.7310398,2.99929059 L12.7310398,2.99929059 Z M12.0327231,5.59763179 L12.2402783,6.20772646 L12.9230769,6.20867234 L12.3702428,6.58513386 L12.5807077,7.19522853 L12.0317532,6.81782113 L11.4789191,7.19428266 L11.6903539,6.58513386 L11.1404294,6.20772646 L11.8203184,6.20867234 L12.0327231,5.59763179 L12.0327231,5.59763179 Z M10.4033173,7.55466416 L10.3587026,8.1950271 L10.9910672,8.43244379 L10.3315458,8.59040629 L10.2869312,9.23076923 L9.9241944,8.68877815 L9.26370313,8.84674065 L9.69821133,8.35393548 L9.33450468,7.81099852 L9.9678392,8.04936109 L10.4033173,7.55466416 L10.4033173,7.55466416 Z" fill="#FFF000"></path></g>';
      break;
    case "JP":
      svg += '<g><rect fill="#FFFFFF" x="0" y="0" width="30" height="20"></rect><path transform="translate(6.000000, 1.000000)" fill="#C30D23" d="M0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 C4.02943725,0 0,4.02943725 0,9 Z"></path></g>';
      break;
    case "US":
      svg += '<g><polygon fill="#FFFFFF" points="0 19.9997354 29.9285525 19.9997354 29.9285525 0 0 0"></polygon><path d="M29.9285525,0.000264616769 L29.9285525,20 L30,20 L29.9285525,20 L29.9285525,0.000264616769 Z M-5.55111512e-17,20 L0.0714474729,20 L0.0714474729,0.000264616769 L-5.55111512e-17,0.000264616769 L-5.55111512e-17,20 Z M0.0714474729,20 L29.9285525,20 L0.0714474729,20 Z" fill="#EFEFEF"></path><path d="M0,1.71383461 L29.9285525,1.71383461 L29.9285525,0 L0,0 L0,1.71383461 Z M0,4.64226018 L29.9285525,4.64226018 L29.9285525,3.21332963 L0,3.21332963 L0,4.64226018 Z M0,7.71446087 L29.9285525,7.71446087 L29.9285525,6.28641237 L0,6.28641237 L0,7.71446087 Z M0,10.7857795 L29.9285525,10.7857795 L29.9285525,9.357731 L0,9.357731 L0,10.7857795 Z M0,13.8570981 L29.9285525,13.8570981 L29.9285525,12.4281676 L0,12.4281676 L0,13.8570981 Z M0,16.9284168 L29.9285525,16.9284168 L29.9285525,15.5003683 L0,15.5003683 L0,16.9284168 Z M0,19.9997354 L29.9285525,19.9997354 L29.9285525,18.5716869 L0,18.5716869 L0,19.9997354 Z" fill="#B72343"></path><polygon fill="#00467B" points="0 10.7857795 11.9996472 10.7857795 11.9996472 0.000882055896 0 0.000882055896"></polygon><path d="M11.0711829,0.929069475 L10.8577225,0.929069475 L10.9997354,1.07196253 L10.92917,1.28542006 L11.1426303,1.142527 L11.2855253,1.28542006 L11.2140778,1.07196253 L11.3569727,0.929069475 L11.2140778,0.929069475 L11.1426303,0.713847837 L11.0711829,0.929069475 Z M9.07241775,0.929069475 L8.85719326,0.929069475 L9.00097027,1.07196253 L9.00097027,1.28542006 L9.14298315,1.142527 L9.2858781,1.28542006 L9.21443063,1.07196253 L9.42877304,0.929069475 L9.21443063,0.929069475 L9.14298315,0.713847837 L9.07241775,0.929069475 Z M7.07188851,0.929069475 L6.85754609,0.929069475 L7.00044103,1.07196253 L6.92899356,1.28542006 L7.14333598,1.142527 L7.28534886,1.28542006 L7.21478345,1.07196253 L7.35679633,0.929069475 L7.14333598,0.929069475 L7.14333598,0.713847837 L7.07188851,0.929069475 Z M5.07224133,0.929069475 L4.85701685,0.929069475 L4.99991179,1.07196253 L4.92846432,1.28542006 L5.14368881,1.142527 L5.28658375,1.28542006 L5.21513628,1.07196253 L5.42859663,0.929069475 L5.21513628,0.929069475 L5.14368881,0.713847837 L5.07224133,0.929069475 Z M3.07171209,0.929069475 L2.85736967,0.929069475 L3.00026462,1.07196253 L2.92881715,1.28542006 L3.14315957,1.142527 L3.28605451,1.28542006 L3.21460704,1.07196253 L3.35750198,0.929069475 L3.21460704,0.929069475 L3.14315957,0.713847837 L3.07171209,0.929069475 Z M1.07118285,0.929069475 L0.856840434,0.929069475 L0.99973538,1.07196253 L0.99973538,1.28542006 L1.14351239,1.142527 L1.28640734,1.28542006 L1.21495987,1.07196253 L1.42930228,0.929069475 L1.21495987,0.929069475 L1.14351239,0.713847837 L1.07118285,0.929069475 Z M10.0709182,1.99988533 L9.85745788,1.99988533 L10.0003528,2.0704498 L9.92890535,2.28478939 L10.1423657,2.14189633 L10.2852607,2.28478939 L10.2138132,2.0704498 L10.4290377,1.99988533 L10.2138132,1.99988533 L10.1423657,1.78554575 L10.0709182,1.99988533 Z M8.07215313,1.99988533 L7.85781071,1.99988533 L8.00070565,2.0704498 L7.92925818,2.28478939 L8.07215313,2.14189633 L8.28561348,2.28478939 L8.21416601,2.0704498 L8.35706095,1.99988533 L8.1436006,1.99988533 L8.07215313,1.78554575 L8.07215313,1.99988533 Z M6.07162389,1.99988533 L5.85728147,1.99988533 L6.00017641,2.0704498 L5.92872894,2.28478939 L6.14307136,2.14189633 L6.28596631,2.28478939 L6.21451883,2.0704498 L6.42797918,1.99988533 L6.21451883,1.99988533 L6.14307136,1.78554575 L6.07162389,1.99988533 Z M4.07197671,1.99988533 L3.85763429,1.99988533 L4.00052924,2.0704498 L3.92908177,2.28478939 L4.14342419,2.14189633 L4.28631913,2.28478939 L4.21487166,2.0704498 L4.3577666,1.99988533 L4.14342419,1.99988533 L4.14342419,1.78554575 L4.07197671,1.99988533 Z M2.07144747,1.99988533 L1.85710505,1.99988533 L2.07144747,2.0704498 L2,2.28478939 L2.14289495,2.14189633 L2.35723736,2.28478939 L2.28578989,2.0704498 L2.4295669,1.99988533 L2.21434242,1.99988533 L2.14289495,1.78554575 L2.07144747,1.99988533 Z" fill="#FFFFFF"></path><path d="M10.0709182,4.14257552 L9.85745788,4.14257552 L10.0003528,4.28546857 L9.92890535,4.49980815 L10.1423657,4.3569151 L10.2852607,4.49980815 L10.2138132,4.28546857 L10.4290377,4.14257552 L10.2138132,4.14257552 L10.1423657,3.99968246 L10.0709182,4.14257552 Z M8.07215313,4.14257552 L7.85781071,4.14257552 L8.00070565,4.28546857 L7.92925818,4.49980815 L8.07215313,4.3569151 L8.28561348,4.49980815 L8.21416601,4.28546857 L8.35706095,4.14257552 L8.1436006,4.14257552 L8.07215313,3.99968246 L8.07215313,4.14257552 Z M6.07162389,4.14257552 L5.85728147,4.14257552 L6.00017641,4.28546857 L5.92872894,4.49980815 L6.14307136,4.3569151 L6.28596631,4.49980815 L6.21451883,4.28546857 L6.42797918,4.14257552 L6.21451883,4.14257552 L6.14307136,3.99968246 L6.07162389,4.14257552 Z M4.07197671,4.14257552 L3.85763429,4.14257552 L4.00052924,4.28546857 L3.92908177,4.49980815 L4.14342419,4.3569151 L4.28631913,4.49980815 L4.21487166,4.28546857 L4.3577666,4.14257552 L4.14342419,4.14257552 L4.14342419,3.99968246 L4.07197671,4.14257552 Z M2.07144747,4.14257552 L1.85710505,4.14257552 L2.07144747,4.28546857 L2,4.49980815 L2.14289495,4.3569151 L2.35723736,4.49980815 L2.28578989,4.28546857 L2.4295669,4.14257552 L2.21434242,4.14257552 L2.14289495,3.99968246 L2.07144747,4.14257552 Z" fill="#FFFFFF"></path><path d="M11.0711829,3.14232413 L10.8577225,3.14232413 L10.9997354,3.28521718 L10.92917,3.49955677 L11.1426303,3.35666371 L11.2855253,3.49955677 L11.2140778,3.28521718 L11.3569727,3.14232413 L11.2140778,3.14232413 L11.1426303,2.9288666 L11.0711829,3.14232413 Z M9.07241775,3.14232413 L8.85719326,3.14232413 L9.00097027,3.28521718 L9.00097027,3.49955677 L9.14298315,3.35666371 L9.2858781,3.49955677 L9.21443063,3.28521718 L9.42877304,3.14232413 L9.21443063,3.14232413 L9.14298315,2.9288666 L9.07241775,3.14232413 Z M7.07188851,3.14232413 L6.85754609,3.14232413 L7.00044103,3.28521718 L6.92899356,3.49955677 L7.14333598,3.35666371 L7.28534886,3.49955677 L7.21478345,3.28521718 L7.35679633,3.14232413 L7.14333598,3.14232413 L7.14333598,2.9288666 L7.07188851,3.14232413 Z M5.07224133,3.14232413 L4.85701685,3.14232413 L4.99991179,3.28521718 L4.92846432,3.49955677 L5.14368881,3.35666371 L5.28658375,3.49955677 L5.21513628,3.28521718 L5.42859663,3.14232413 L5.21513628,3.14232413 L5.14368881,2.9288666 L5.07224133,3.14232413 Z M3.07171209,3.14232413 L2.85736967,3.14232413 L3.00026462,3.28521718 L2.92881715,3.49955677 L3.14315957,3.35666371 L3.28605451,3.49955677 L3.21460704,3.28521718 L3.35750198,3.14232413 L3.21460704,3.14232413 L3.14315957,2.9288666 L3.07171209,3.14232413 Z M1.07118285,3.14232413 L0.856840434,3.14232413 L0.99973538,3.28521718 L0.99973538,3.49955677 L1.14351239,3.35666371 L1.28640734,3.49955677 L1.21495987,3.28521718 L1.42930228,3.14232413 L1.21495987,3.14232413 L1.14351239,2.9288666 L1.07118285,3.14232413 Z" fill="#FFFFFF"></path><path d="M10.0709182,6.4288644 L9.85745788,6.4288644 L10.0003528,6.57175745 L9.92890535,6.78521498 L10.1423657,6.64320398 L10.2852607,6.78521498 L10.2138132,6.57175745 L10.4290377,6.4288644 L10.2138132,6.4288644 L10.1423657,6.21364276 L10.0709182,6.4288644 Z M8.07215313,6.4288644 L7.85781071,6.4288644 L8.00070565,6.57175745 L7.92925818,6.78521498 L8.07215313,6.64320398 L8.28561348,6.78521498 L8.21416601,6.57175745 L8.35706095,6.4288644 L8.1436006,6.4288644 L8.07215313,6.21364276 L8.07215313,6.4288644 Z M6.07162389,6.4288644 L5.85728147,6.4288644 L6.00017641,6.57175745 L5.92872894,6.78521498 L6.14307136,6.64320398 L6.28596631,6.78521498 L6.21451883,6.57175745 L6.42797918,6.4288644 L6.21451883,6.4288644 L6.14307136,6.21364276 L6.07162389,6.4288644 Z M4.07197671,6.4288644 L3.85763429,6.4288644 L4.00052924,6.57175745 L3.92908177,6.78521498 L4.14342419,6.64320398 L4.28631913,6.78521498 L4.21487166,6.57175745 L4.3577666,6.4288644 L4.14342419,6.4288644 L4.14342419,6.21364276 L4.07197671,6.4288644 Z M2.07144747,6.4288644 L1.85710505,6.4288644 L2.07144747,6.57175745 L2,6.78521498 L2.14289495,6.64320398 L2.35723736,6.78521498 L2.28578989,6.57175745 L2.4295669,6.4288644 L2.21434242,6.4288644 L2.14289495,6.21364276 L2.07144747,6.4288644 Z" fill="#FFFFFF"></path><path d="M11.0711829,5.42861301 L10.8577225,5.42861301 L10.9997354,5.50005954 L10.92917,5.71439912 L11.1426303,5.64295259 L11.2855253,5.71439912 L11.2140778,5.50005954 L11.3569727,5.42861301 L11.2140778,5.42861301 L11.1426303,5.21427343 L11.0711829,5.42861301 Z M9.07241775,5.42861301 L8.85719326,5.42861301 L9.00097027,5.50005954 L9.00097027,5.71439912 L9.14298315,5.64295259 L9.2858781,5.71439912 L9.21443063,5.50005954 L9.42877304,5.42861301 L9.21443063,5.42861301 L9.14298315,5.21427343 L9.07241775,5.42861301 Z M7.07188851,5.42861301 L6.85754609,5.42861301 L7.00044103,5.50005954 L6.92899356,5.71439912 L7.14333598,5.64295259 L7.28534886,5.71439912 L7.21478345,5.50005954 L7.35679633,5.42861301 L7.14333598,5.42861301 L7.14333598,5.21427343 L7.07188851,5.42861301 Z M5.07224133,5.42861301 L4.85701685,5.42861301 L4.99991179,5.50005954 L4.92846432,5.71439912 L5.14368881,5.64295259 L5.28658375,5.71439912 L5.21513628,5.50005954 L5.42859663,5.42861301 L5.21513628,5.42861301 L5.14368881,5.21427343 L5.07224133,5.42861301 Z M3.07171209,5.42861301 L2.85736967,5.42861301 L3.00026462,5.50005954 L2.92881715,5.71439912 L3.14315957,5.64295259 L3.28605451,5.71439912 L3.21460704,5.50005954 L3.35750198,5.42861301 L3.21460704,5.42861301 L3.14315957,5.21427343 L3.07171209,5.42861301 Z M1.07118285,5.42861301 L0.856840434,5.42861301 L0.99973538,5.50005954 L0.99973538,5.71439912 L1.14351239,5.64295259 L1.28640734,5.71439912 L1.21495987,5.50005954 L1.42930228,5.42861301 L1.21495987,5.42861301 L1.14351239,5.21427343 L1.07118285,5.42861301 Z" fill="#FFFFFF"></path><path d="M10.0709182,8.71356558 L9.85745788,8.71356558 L10.0003528,8.85645863 L9.92890535,9.00023374 L10.1423657,8.92878722 L10.2852607,9.00023374 L10.2138132,8.85645863 L10.4290377,8.71356558 L10.2138132,8.71356558 L10.1423657,8.50010805 L10.0709182,8.71356558 Z M8.07215313,8.71356558 L7.85781071,8.71356558 L8.00070565,8.85645863 L7.92925818,9.00023374 L8.07215313,8.92878722 L8.28561348,9.00023374 L8.21416601,8.85645863 L8.35706095,8.71356558 L8.1436006,8.71356558 L8.07215313,8.50010805 L8.07215313,8.71356558 Z M6.07162389,8.71356558 L5.85728147,8.71356558 L6.00017641,8.85645863 L5.92872894,9.00023374 L6.14307136,8.92878722 L6.28596631,9.00023374 L6.21451883,8.85645863 L6.42797918,8.71356558 L6.21451883,8.71356558 L6.14307136,8.50010805 L6.07162389,8.71356558 Z M4.07197671,8.71356558 L3.85763429,8.71356558 L4.00052924,8.85645863 L3.92908177,9.00023374 L4.14342419,8.92878722 L4.28631913,9.00023374 L4.21487166,8.85645863 L4.3577666,8.71356558 L4.14342419,8.71356558 L4.14342419,8.50010805 L4.07197671,8.71356558 Z M2.07144747,8.71356558 L1.85710505,8.71356558 L2.07144747,8.85645863 L2,9.00023374 L2.14289495,8.92878722 L2.35723736,9.00023374 L2.28578989,8.85645863 L2.4295669,8.71356558 L2.21434242,8.71356558 L2.14289495,8.50010805 L2.07144747,8.71356558 Z" fill="#FFFFFF"></path><path d="M11.0711829,7.64266152 L10.8577225,7.64266152 L10.9997354,7.78555457 L10.92917,7.99989415 L11.1426303,7.8570011 L11.2855253,7.99989415 L11.2140778,7.78555457 L11.3569727,7.64266152 L11.2140778,7.64266152 L11.1426303,7.50065052 L11.0711829,7.64266152 Z M9.07241775,7.64266152 L8.85719326,7.64266152 L9.00097027,7.78555457 L9.00097027,7.99989415 L9.14298315,7.8570011 L9.2858781,7.99989415 L9.21443063,7.78555457 L9.42877304,7.64266152 L9.21443063,7.64266152 L9.14298315,7.50065052 L9.07241775,7.64266152 Z M7.07188851,7.64266152 L6.85754609,7.64266152 L7.00044103,7.78555457 L6.92899356,7.99989415 L7.14333598,7.8570011 L7.28534886,7.99989415 L7.21478345,7.78555457 L7.35679633,7.64266152 L7.14333598,7.64266152 L7.14333598,7.50065052 L7.07188851,7.64266152 Z M5.07224133,7.64266152 L4.85701685,7.64266152 L4.99991179,7.78555457 L4.92846432,7.99989415 L5.14368881,7.8570011 L5.28658375,7.99989415 L5.21513628,7.78555457 L5.42859663,7.64266152 L5.21513628,7.64266152 L5.14368881,7.50065052 L5.07224133,7.64266152 Z M3.07171209,7.64266152 L2.85736967,7.64266152 L3.00026462,7.78555457 L2.92881715,7.99989415 L3.14315957,7.8570011 L3.28605451,7.99989415 L3.21460704,7.78555457 L3.35750198,7.64266152 L3.21460704,7.64266152 L3.14315957,7.50065052 L3.07171209,7.64266152 Z M1.07118285,7.64266152 L0.856840434,7.64266152 L0.99973538,7.78555457 L0.99973538,7.99989415 L1.14351239,7.8570011 L1.28640734,7.99989415 L1.21495987,7.78555457 L1.42930228,7.64266152 L1.21495987,7.64266152 L1.14351239,7.50065052 L1.07118285,7.64266152 Z" fill="#FFFFFF"></path><path d="M11.0711829,9.78526349 L10.8577225,9.78526349 L10.9997354,9.92815655 L10.92917,10.1424961 L11.1426303,9.99960307 L11.2855253,10.1424961 L11.2140778,9.92815655 L11.3569727,9.78526349 L11.2140778,9.78526349 L11.1426303,9.57092391 L11.0711829,9.78526349 Z M9.07241775,9.78526349 L8.85719326,9.78526349 L9.00097027,9.92815655 L9.00097027,10.1424961 L9.14298315,9.99960307 L9.2858781,10.1424961 L9.21443063,9.92815655 L9.42877304,9.78526349 L9.21443063,9.78526349 L9.14298315,9.57092391 L9.07241775,9.78526349 Z M7.07188851,9.78526349 L6.85754609,9.78526349 L7.00044103,9.92815655 L6.92899356,10.1424961 L7.14333598,9.99960307 L7.28534886,10.1424961 L7.21478345,9.92815655 L7.35679633,9.78526349 L7.14333598,9.78526349 L7.14333598,9.57092391 L7.07188851,9.78526349 Z M5.07224133,9.78526349 L4.85701685,9.78526349 L4.99991179,9.92815655 L4.92846432,10.1424961 L5.14368881,9.99960307 L5.28658375,10.1424961 L5.21513628,9.92815655 L5.42859663,9.78526349 L5.21513628,9.78526349 L5.14368881,9.57092391 L5.07224133,9.78526349 Z M3.07171209,9.78526349 L2.85736967,9.78526349 L3.00026462,9.92815655 L2.92881715,10.1424961 L3.14315957,9.99960307 L3.28605451,10.1424961 L3.21460704,9.92815655 L3.35750198,9.78526349 L3.21460704,9.78526349 L3.14315957,9.57092391 L3.07171209,9.78526349 Z M1.07118285,9.78526349 L0.856840434,9.78526349 L0.99973538,9.92815655 L0.99973538,10.1424961 L1.14351239,9.99960307 L1.28640734,10.1424961 L1.21495987,9.92815655 L1.42930228,9.78526349 L1.21495987,9.78526349 L1.14351239,9.57092391 L1.07118285,9.78526349 Z" fill="#FFFFFF"></path></g>';
      break;
    default: break;
  }
  return svg
}

// 检查是否存在验证码定时器: timer: 当前剩余秒数, timerInterval: 定时器, check: 是否需要检查
export const countdown = (param, check) => {
  function start() {
    param.timerInterval = setInterval(() => {
      param.timer += -1;
      if (param.timer <= 0) {
        clearInterval(param.timerInterval);
        param.timerLoading = false;
        localStorage.removeItem("codeTimer");
      }
    }, 1000);
  }

  if (check) {
    let localTimer = localStorage.getItem("codeTimer");
    if (localTimer && new Date().getTime() - Number(localTimer) < 60000) {
      param.timer = 60 - Math.round((new Date().getTime() - Number(localTimer)) / 1000);
      start(param.timer)
    }
  } else {
    clearInterval(param.timerInterval);
    param.timer = 60;
    localStorage.setItem("codeTimer", new Date().getTime().toString());
    start(param.timer)
  }
}

// 处理语言, 以及记录中的默认语种
export const handleLang = (param, r) => {
  // 后端语言标识为EN_US, 需要格式化为标准的en-US
  for (let i in r) {
    let code = r[i].language_code.split(/\_|\-/);
    let lang = `${code[0].toLowerCase()}-${code[1].toUpperCase()}`;
    r[i].language_code = lang;

    if (r[i].is_default) {
      param.currentLang = lang;
      param.current = r[i]
    }
  }
  // 如果没有默认站点的情况下, 默认取US站点
  if (!param.currentLang) {
    param.current = param.list.find(item => item.cr === 'US')
    param.currentLang = param.current.language_code
  }
  param.list = r
}

// 表单循环校验, 而不是所有的一起校验, 抛弃Form.value.validate()
export const formValidate = (rule, v, data, field) => {
  const arr = [];
  for (let i in rule) { rule[i][0].required && arr.push(rule[i][0].validator(null, v[i])) }
  Promise.all(arr).then(() => { data[field] = false }).catch(() => { data[field] = true })
}

// 获得视频第一帧缩略图, getVideoBase64(url) .then(res => { console.log(res) })
export const getVideoBase64 = (url) => {
  return new Promise(function (resolve) {
    let dataURL = ''
    let video = document.createElement('video')
    video.setAttribute('crossOrigin', 'anonymous') //处理跨域
    video.setAttribute('src', url)
    video.setAttribute('width', '100%')
    video.setAttribute('height', '100%')
    video.setAttribute('autoplay', 'autoplay')
    video.currentTime = 1
    video.addEventListener('canplaythrough', function () {
      let canvas = document.createElement('canvas'),
        width = video.width, //canvas的尺寸和图片一样
        height = video.height
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(video, 0, 0, width, height) //绘制canvas
      dataURL = canvas.toDataURL('image/jpeg') //转换为base64
      resolve(dataURL)
    })
  })
}

// 下载pdf文件, 而不是直接在浏览器打开
export const downloadFile = (url) => {
  let blob = "";
  let xhr = new XMLHttpRequest();
  xhr.onload = function(){
    if (this.status === 200) {
      blob = new Blob([xhr.response], { type: 'application/pdf' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = url.split('/').pop();
      link.click();
      // document.body.removeChild(link)
    } else {
      console.log("Error. Estatus " + this.status + ".")
    }
  };

  try {
    xhr.open('GET', url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.responseType = 'blob';
    xhr.send('parameter1=&parameter2=');
  } catch (e) {
    console.log(e)
  }
}


// 是否为 iOS 移动终端
const isiOS = () => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

// 去会员中心, go shipping, 切换站点都需要登录到shopify, 再跳转回原处, 过程很繁琐, 需要优化
export const uLogin = (api, shop_id, url, openWindow = true) => {
  let u = url.replace("https://https://", "https://");
  let param = {
    token: cookie.get("_jk_id"),
    shop_id,
    return_url: u || `${location.origin}/account/overview`
  };
  api(param).then(r => {
    cookie.set("_jk_user", r.jackery_token);
    if (openWindow) {
      // 因为苹果的安全机制拦截了，所以不能打开新的标签页
      isiOS() ? (window.location.href = r.redirect_url) : window.open(r.redirect_url)
    } else {
      window.location.href = r.redirect_url
    }
  }).catch(e => {
    window.location.href = `/login?redirect_url=${url}`
  })
}

// 一维数组 转 二位数组
export const chunkArray = (arr = [], num = 2) => {
    const cloneArray = [...arr]
    const newArray = []
    while(cloneArray.length > 0) {
      newArray.push(cloneArray.splice(0, num));
    }
    return newArray
}


/** ----------- cdp start ----------- */
// 获取referer信息
export const getRefererPage = () => {
  return cookie.get("_referer_page_info") ? JSON.parse(cookie.get("_referer_page_info")) : {url: '', title: ''}
}

export const saveOtherEmail = (val) => {
  cookie.set("_other_email", val)
}

export const getOtherEmail = () => {
  return cookie.get("_other_email") || ''
}

// 保存清除jackery userid、eamil至cookie
export const setLoginCookie = (id, email) => {
  cookie.set("_jk_user_id", id || '')
  cookie.set("_jk_user_email", email || '')
}

export const clearLoginCookie = () => {
  cookie.erase("_jk_user_id")
  cookie.erase("_jk_user_email")
}

export const objType = (obj) => {
  const res = Object.prototype.toString.call(obj)
  return res.replace('[object ', '').replace(']', '').toLowerCase()
}
/** ----------- cdp end ----------- */



export class CuntDown {
  constructor(options) {
    this.onFinish = options.onFinish
    this.counting = false

    this.updateCb = options.updateCb

    // 剩余时间
    this.remain = options.time

    // 结束时间
    this.endTime = 0
    this.format = options.format

    this.begin = options.begin || Date.now()

    this.init();
  }

  init() {
    console.log(this.currentTime().format)
    this.start()
  }

  currentTime() {
    return this.formatTime(this.format, this.parseTime(this.remain))
  }

  getCurrentRemain() {
    return Math.max(this.endTime - this.begin, 0)
  }

  formatTime(format, time) {
    let {
      days,
      hours,
      minutes,
      seconds,
      milliseconds
    } = time

    // 判断是否需要展示 天数，需要则补 0，否则将 天数 降级加到 小时 部分
    if (format.includes('DD')) {
      format = format.replace('DD', this.padZero(days))
    } else if(format.includes('days')) {
        format = format.replace('days', this.padZero(days))
    } else {
      hours += days * 24
    }

    // 判断是否需要展示 小时，需要则补 0，否则将 小时 降级加到 分钟 部分
    if (format.includes('HH')) {
      format = format.replace('HH', this.padZero(hours))
    } else {
      minutes += hours * 60
    }

    // 判断是否需要展示 分钟，需要则补 0，否则将 分钟 降级加到 秒数 部分
    if (format.includes('mm')) {
      format = format.replace('mm', this.padZero(minutes))
    } else {
      seconds += minutes * 60
    }

    // 判断是否需要展示 秒数，需要则补 0，否则将 秒数 降级加到 毫秒 部分
    if (format.includes('ss')) {
      format = format.replace('ss', this.padZero(seconds))
    } else {
      milliseconds += seconds * 1000
    }

    // 默认展示 3位 毫秒数
    if (format.includes('SSS')) {
      const ms = this.padZero(milliseconds, 3)
      format = format.replace('SSS', ms)
    }

    // 最终返回格式化的数据
    return {
      format,
      days,
      hours,
      minutes,
      seconds,
      milliseconds
    }
  }

  padZero(str, padLength = 2) {
    str += ''
    if (str.length < padLength) {
      str = '0'.repeat(padLength - str.length) + str
    }
    return str
  }

  parseTime(time) {
    const SECOND = 1000
    const MINUTE = 60 * SECOND
    const HOUR = 60 * MINUTE
    const DAY = 24 * HOUR

    const days = Math.floor(time / DAY)
    const hours = Math.floor((time % DAY) / HOUR)
    const minutes = Math.floor((time % HOUR) / MINUTE)
    const seconds = Math.floor((time % MINUTE) / SECOND)
    const milliseconds = Math.floor(time % SECOND)

    return {
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
    }
  }

  // 设置剩余时间
  setRemain(value) {

    // 更新剩余时间
    this.remain = value

    // 倒计时结束
    if (value === 0) {
      if (this.onFinish) {
        this.onFinish()
      }

      // 正在倒计时标志为 false
      this.counting = false
    }
  }

  // 倒计时
  tickTime() {
    setTimeout(() => {
      // 更新剩余时间
      this.setRemain(this.getCurrentRemain())
      this.begin += 1000

      // 倒计时没结束，就继续
      if (this.remain > 0) {
        this.tickTime()
      }

      this.updateCb(this.currentTime())
    }, 1000);

    // requestAnimationFrame(() => {
    //   // 更新剩余时间
    //   this.setRemain(this.getCurrentRemain())

    //   // 倒计时没结束，就继续
    //   if (this.remain > 0) {
    //     this.tickTime()
    //   }

    //   // document.querySelector('#count-down').innerHTML = this.currentTime().format
    //   this.updateCb(this.currentTime())
    // })
  }

  // 启动
  start() {
    // 正在倒计时，忽略多次调用 start
    if (this.counting) return

    // 正在倒计时标志为 true
    this.counting = true

    // 设置结束时间
    // this.endTime = Date.now() + this.remain
    this.endTime = this.begin + this.remain

    // 开启倒计时
    this.tickTime()
  }
}
